import { render, staticRenderFns } from "./ProofOfAddress.vue?vue&type=template&id=829297ec&scoped=true"
import script from "./ProofOfAddress.vue?vue&type=script&lang=js"
export * from "./ProofOfAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829297ec",
  null
  
)

export default component.exports